import React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const PricingIcon: React.FC<SvgIconProps> = ({ style, ...props }) => {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={{
        ...style,
      }}
      {...props}
    >
      <path
        d="m11 9h4a1 1 0 0 0 0-2h-2v-1a1 1 0 0 0 -2 0v1a3 3 0 0 0 0 6h2a1 1 0 0 1 0 2h-4a1 1 0 0 0 0 2h2v1a1 1 0 0 0 2 0v-1a3 3 0 0 0 0-6h-2a1 1 0 0 1 0-2zm1-8a11 11 0 1 0 11 11 11 11 0 0 0 -11-11zm0 20a9 9 0 1 1 9-9 9 9 0 0 1 -9 9z"
        fill={props.htmlColor}
      />
    </SvgIcon>
  );
};

export default React.memo(PricingIcon);
